// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartSummarySharedStyles from "@guestsupply/App/SharedStyles/CartSummarySharedStyles";
import { orderTotalDisplayStyles } from "@guestsupply/Overrides/Components/OrderTotalDisplay";
import { css } from "styled-components";

orderTotalDisplayStyles.container = {
    ...cartSummarySharedStyles.container,
};
orderTotalDisplayStyles.titleGridItem = {
    ...cartSummarySharedStyles.titleGridItem,
};
orderTotalDisplayStyles.titleText = {
    ...cartSummarySharedStyles.titleText,
};
orderTotalDisplayStyles.dividerGridItem = {
    ...cartSummarySharedStyles.dividerGridItem,
};
orderTotalDisplayStyles.labelGridItem = { ...cartSummarySharedStyles.labelGridItem };
orderTotalDisplayStyles.valueGridItem = { ...cartSummarySharedStyles.valueGridItem };
orderTotalDisplayStyles.totalLabelGridItem = { width: 6 };
orderTotalDisplayStyles.totalValueGridItem = { width: 6 };
orderTotalDisplayStyles.subtotalValue = {
    ...cartSummarySharedStyles.valueText,
};
orderTotalDisplayStyles.promotionValue = {
    ...cartSummarySharedStyles.valueText,
};
orderTotalDisplayStyles.discountsValue = {
    ...cartSummarySharedStyles.valueText,
};
orderTotalDisplayStyles.shippingAndHandlingValue = {
    ...cartSummarySharedStyles.valueText,
};
orderTotalDisplayStyles.otherChargesValue = {
    ...cartSummarySharedStyles.valueText,
};
orderTotalDisplayStyles.taxValue = {
    ...cartSummarySharedStyles.valueText,
};
orderTotalDisplayStyles.totalLabel = {
    ...cartSummarySharedStyles.totalLabel,
};
orderTotalDisplayStyles.totalValue = {
    ...cartSummarySharedStyles.totalValue,
};
// OOTB Style
orderTotalDisplayStyles.loadingSpinner = {
    size: 15,
    css: css`
        margin-top: auto;
        margin-bottom: auto;
        margin-left: auto;
    `,
};
orderTotalDisplayStyles.subtotalLabel = {
    ...cartSummarySharedStyles.labelText,
};
orderTotalDisplayStyles.promotionLabel = {
    ...cartSummarySharedStyles.labelText,
};
orderTotalDisplayStyles.discountsLabel = {
    ...cartSummarySharedStyles.labelText,
};
orderTotalDisplayStyles.shippingAndHandlingLabel = {
    ...cartSummarySharedStyles.labelText,
};
orderTotalDisplayStyles.otherChargesLabel = {
    ...cartSummarySharedStyles.labelText,
};
orderTotalDisplayStyles.taxLabel = {
    ...cartSummarySharedStyles.labelText,
};
orderTotalDisplayStyles.wrapper = {
    css: css``,
};
